import translator from 'core/localization/localization';

export { translator } from './localization';

export const i18n = translator({
	'Validate': {
		no: 'Validering',
	},
	'Unit Label': {
		no: 'Enhet Navn',
	},
	'Formula': {
		no: 'Formel',
	},
	'Create assetgroup': {
		no: 'Opprett assetgruppe',
	},
	'Rediscover disks': {
		no: 'Søk etter disker på nytt',
	},
	'{0} configuration': {
		no: '{0} konfigurasjon',
	},
	'Dirty confirmation': {
		en: 'You have unsaved content in monitor. You will lose the changes if you click close. Click cancel and save the changes if you want to keep them.',
		no: 'Du har ulagret innhold i loggmonitoren, du vil miste endringen hvis du klikker lukk. Trykk avbryt og lagre endringen hvis du vil beholde dem.',
	},
	'Rows and Columns': {
		no: 'Rader og kolonner',
	},
	'Radial': {
		no: 'Radial',
	},
	'Thresholds': {
		no: 'Grenser',
	},
	'Thresholds value': {
		no: 'Grenseverdi',
	},
});
